"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onDocumentLoaded = onDocumentLoaded;
exports.executeOnceWhenIdle = executeOnceWhenIdle;
exports.kebabCase = kebabCase;
function onDocumentLoaded(node, callback, requireComplete = false) {
    let doc, cb, rc;
    if (typeof node === 'function') {
        doc = document;
        cb = () => node.call(document, document);
        rc = callback ?? false;
    }
    else {
        if (node !== null) {
            if (node instanceof Document) {
                doc = node;
            }
            else if (node.nodeName === "#document") {
                doc = node;
            }
            else if (node.ownerDocument !== null) {
                doc = node.ownerDocument;
            }
            else {
                throw new Error(`Unable to resolve the document containing for ${node}.`);
            }
        }
        else {
            doc = document;
        }
        if (typeof callback !== 'function') {
            throw new Error("The second argument to onDocumentLoaded must be a function when passing anything other than a function as its first argument");
        }
        cb = () => callback.call(node, node);
        rc = requireComplete;
    }
    if (doc.readyState === "complete" || (!rc && doc.readyState === "interactive")) {
        cb();
    }
    else if (rc) {
        doc.defaultView.addEventListener("load", cb);
    }
    else {
        doc.addEventListener("DOMContentLoaded", cb);
    }
}
/**
 * Executes a callback function once after document load and when the browser is idle.
 * Falls back to requestAnimationFrame if requestIdleCallback is not supported.
 *
 * @param callback Function to execute.
 * @param timeout Maximum time to wait before executing (in milliseconds), defaults to 10 seconds.
 * @returns Function to cancel the scheduled callback.
 */
function executeOnceWhenIdle(callback, timeout = 10_000) {
    let idleCallbackId = null;
    const scheduleCallback = () => {
        if ('requestIdleCallback' in window) {
            idleCallbackId = window.requestIdleCallback(callback, { timeout });
        }
        else {
            idleCallbackId = requestAnimationFrame(callback);
        }
    };
    if (document.readyState === 'complete') {
        scheduleCallback();
    }
    else {
        document.addEventListener('DOMContentLoaded', scheduleCallback, { once: true });
    }
    return () => {
        if (idleCallbackId !== null) {
            if ('requestIdleCallback' in window) {
                window.cancelIdleCallback(idleCallbackId);
            }
            else {
                cancelAnimationFrame(idleCallbackId);
            }
        }
    };
}
function kebabCase(value) {
    return value
        .replaceAll(/([a-z])([A-Z])/g, "$1-$2")
        .replaceAll(/[^a-zA-Z0-9]+/g, '-')
        .toLowerCase();
}
//# sourceMappingURL=lib.js.map